/*
 * Loading.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */

import { useEffect, useState } from 'react'
import { localization } from '../../config/localize/localizable'
import { useDebounce } from '../../config/use/useDebounce'
import FormikTextField from '../element/FormikTextField'

const SimpleSearch = ({ completion }) => {
    const [searchTerm, setSearchTerm] = useState('')
    // Searching status (whether there is pending API request)
    const [isSearching, setIsSearching] = useState(false)

    const debouncedSearchTerm = useDebounce(searchTerm, 400)

    // Effect for API call
    useEffect(
        () => { 
            if (debouncedSearchTerm) {
                setIsSearching(true)
            } else {
                setIsSearching(false)
            }
            if (completion) completion(searchTerm)
        },
        [debouncedSearchTerm] // Only call effect if debounced search term changes
    )

    return (
        <>
            <div className="col-span-5 text-right mt-2 ml-2 justify-end ">
                <FormikTextField placeHolder={localization.search} onChange={(e) => setSearchTerm(e)} />
            </div>
        </>
    )
}

export default SimpleSearch
